/**
 * SHA-256 hexadecimal minúsculo, pelo WebCrypto do navegador.
 *
 * O servidor RECALCULA os dois resumos sobre o que recebeu. Este cálculo local
 * não autoriza nada — ele existe para que um lote montado na interface tenha a
 * mesma identidade que o mesmo lote montado no aparelho.
 */
export async function sha256Hex(text: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
